<div [ngClass]="{'hidden': !this._loaderService.displayBigLoader }" class="page-loader-container">
    <div class="container">
        <img class="logo" src="../../../../assets/images/acciona_logo.svg" />
        <!-- <div class="loading">Loading</div> -->
        <div class="loader"></div>
        <div class="gooey">
            <span class="dot"></span>
            <div class="dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
    </div>
</div>
<div [ngClass]="{'hidden': this._loaderService.liveRequests == 0 }" class="process-loader-container">
  <div class="container">
    <div class="loader"></div>
  </div>
</div>